var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBoardGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1660_100348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1660_100348)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1660_100348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1660_100348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9158 3.72831H12.2908C12.096 3.72951 11.9041 3.77464 11.7292 3.86035C11.5543 3.94605 11.401 4.07012 11.2808 4.22331L15.1649 13.39C15.2992 13.7076 15.302 14.0655 15.1726 14.3852C15.0433 14.7049 14.7923 14.9602 14.4749 15.095L14.1674 15.2266H17.9133C18.2572 15.2247 18.5863 15.0866 18.8288 14.8428C19.0713 14.5989 19.2074 14.2689 19.2074 13.925V5.02831C19.2079 4.68452 19.0723 4.35452 18.8303 4.11033C18.5883 3.86615 18.2595 3.72762 17.9158 3.72498V3.72831ZM15.3016 11.2733L13.5883 9.13414L15.1416 6.78581L16.6699 9.04498L15.3016 11.2733Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4656 13.1899L10.2156 3.17993L10.1439 3.01326C9.99695 2.66627 9.7182 2.39183 9.36896 2.25025C9.01972 2.10868 8.62856 2.11156 8.28144 2.25826L1.7406 5.03326C1.56848 5.10604 1.4124 5.21203 1.28127 5.34518C1.15015 5.47833 1.04657 5.63602 0.976445 5.80924C0.906322 5.98245 0.871037 6.1678 0.872609 6.35466C0.87418 6.54153 0.912577 6.72625 0.985603 6.89826L5.3006 17.0774C5.4483 17.4238 5.7271 17.6977 6.07609 17.8392C6.42509 17.9806 6.81589 17.9782 7.1631 17.8324L13.3673 15.1983L13.7006 15.0549C13.8731 14.9829 14.0296 14.8775 14.1611 14.7447C14.2927 14.612 14.3966 14.4545 14.467 14.2814C14.5375 14.1082 14.5729 13.9229 14.5714 13.736C14.5698 13.5491 14.5314 13.3644 14.4581 13.1924L14.4656 13.1899ZM9.00644 11.4024C8.82144 11.3666 8.63977 11.3099 8.40727 11.2474L9.39977 12.4699L8.52727 12.8633C8.43477 12.3083 8.34477 11.7799 8.25894 11.2449L8.19644 11.2266C8.15476 11.3889 8.10214 11.5481 8.03894 11.7033C7.97412 11.9166 7.84825 12.1063 7.67687 12.2489C7.50549 12.3915 7.2961 12.4808 7.07455 12.5058C6.85299 12.5308 6.62896 12.4904 6.43012 12.3895C6.23127 12.2887 6.06632 12.1318 5.9556 11.9383C5.78073 11.7117 5.66376 11.4459 5.61482 11.1639C5.56589 10.8819 5.58646 10.5922 5.67477 10.3199C5.88038 9.68251 6.19505 9.0856 6.60477 8.55576C6.6734 8.42099 6.78461 8.31264 6.92113 8.24754C7.05765 8.18245 7.21184 8.16425 7.35977 8.19576C7.93168 8.25872 8.49915 8.35696 9.05894 8.48993C9.41206 8.59445 9.72586 8.80216 9.96004 9.08638C10.1942 9.3706 10.3381 9.71834 10.3731 10.0849C10.4247 10.2721 10.4248 10.4698 10.3734 10.6571C10.322 10.8444 10.221 11.0143 10.081 11.1489C9.94101 11.2835 9.76728 11.3778 9.57814 11.4218C9.389 11.4659 9.19148 11.458 9.00644 11.3991V11.4024Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoardGame);
export default __webpack_public_path__ + "static/media/icon-board-game.097e4f4092b4f38e86a86a7683c04643.svg";
export { ForwardRef as ReactComponent };